import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MantineProvider, createTheme } from "@mantine/core";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider, createBrowserRouter } from "react-router";

import "@mantine/core/styles.css";

import { App } from "./App";
import { Home } from "./routes/Home";
import { RandomBlend } from "./routes/RandomBlend";

const theme = createTheme({});

// HowItWorks is static copy — keep it out of the home-route bundle so
// the initial load doesn't pay for it.
const router = createBrowserRouter([
  {
    path: "/",
    Component: App,
    children: [
      { index: true, Component: Home },
      { path: "blend/:seed", Component: RandomBlend },
      {
        path: "how-it-works",
        lazy: async () => {
          const mod = await import("./routes/HowItWorks");
          return { Component: mod.HowItWorks };
        },
      },
    ],
  },
]);

const queryClient = new QueryClient();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("missing #root element");
}

createRoot(rootElement).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="dark">
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ReactQueryDevtools buttonPosition="bottom-right" initialIsOpen={false} />
      </QueryClientProvider>
    </MantineProvider>
  </StrictMode>,
);
